"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const v2_1 = require("smartrips-skin/lib/v2");
const getAnimations = () => {
    return `
    @keyframes dash-animation {
      0% {
        stroke-dasharray: 1px, 200px;
        stroke-dashoffset: 0px;
      };
      50% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -15px; 
      }
      100% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -125px;
      }
    }
    
    @keyframes spin-animation {
      100% {
        transform: rotate(360deg);
      };
    }
  `;
};
const getColors = ({ variant, }) => {
    switch (variant) {
        case "blue":
            return `
        color: ${v2_1.theme.colors.blue[500]};
      `;
        case "default":
            return `
        color: ${v2_1.theme.colors.gray[500]};
      `;
        case "green":
            return `
        color: ${v2_1.theme.colors.green[500]};
      `;
        case "pink":
            return `
        color: ${v2_1.theme.colors.pink[500]};
      `;
        default:
            return `
        color: ${v2_1.theme.colors.gray[500]};
      `;
    }
};
exports.styles = {
    circle: styled_1.default.circle `
    ${() => getAnimations()}
    animation: dash-animation 1.4s ease-in-out infinite;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0px;
    stroke: currentColor;
  `,
    root: styled_1.default.span `
    align-items: center;
    animation: spin-animation 1.4s linear infinite;
    aspect-ratio: 1;
    display: flex;
    height: ${({ size }) => size}px;
    justify-content: center;
    width: ${({ size }) => size}px;
    ${({ variant }) => getColors({ variant })}
  `,
    svg: styled_1.default.svg `
    border-radius: 50%;
    display: inline-block;
  `,
};
